var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polyline, _polyline2, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvansLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Evans_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.8,82.7a12.437,12.437,0,0,1-8.9-3.2,11.754,11.754,0,0,1-3.6-8.7c0-7,5.1-11.9,13.1-11.9a17.544,17.544,0,0,1,8.1,1.9v5.4a13.784,13.784,0,0,0-7.7-2.5c-4.7,0-7.5,2.7-7.5,7.1,0,4.2,2.7,7.1,7,7.1A14.421,14.421,0,0,0,75.6,75v5.4A17.774,17.774,0,0,1,66.8,82.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102,71.8,92.9,59.2h6.9l5.1,7.5,5.2-7.5h6.8l-9.2,12.6V82.3H102Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.4,82.7a12.436,12.436,0,0,1-8.9-3.2,11.754,11.754,0,0,1-3.6-8.7c0-7,5.1-11.9,13.1-11.9a17.544,17.544,0,0,1,8.1,1.9v5.4a13.784,13.784,0,0,0-7.7-2.5c-4.7,0-7.5,2.7-7.5,7.1,0,4.2,2.7,7.1,7,7.1a14.421,14.421,0,0,0,8.3-2.9v5.4A17.5,17.5,0,0,1,143.4,82.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.5,59.2h5.8V77.8h9.9v4.5H172.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.7,59.2h15.4v4.2h-9.6v4.7h9.2v4.3h-9.2v5.5h9.9v4.3H207.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.5,75.3c2.9,1.8,5.3,2.9,7.9,2.9,2.3,0,3.4-.7,3.4-2.1s-1-1.8-3.1-2.5c-5.8-2-8.6-3.9-8.6-8.1,0-3.8,3.4-6.6,8.7-6.6a17.542,17.542,0,0,1,7.8,1.9v4.7a17.105,17.105,0,0,0-7.5-2.3c-2.2,0-3.4.7-3.4,1.9,0,.9,1,1.8,3.1,2.6a29.715,29.715,0,0,1,5.7,2.5,6.321,6.321,0,0,1,3,5.8c0,4.2-3.3,6.8-9.1,6.8a15.073,15.073,0,0,1-8-2.2V75.3Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191 11.2 208.9 11.2 228.8 28 234.6 11.2 247.7 11.2 239.8 34.1 220.4 34.1 202.1 17.5 196.3 34.1 183.1 34.1 188.9 17.2 186.2 11.2 191 11.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162,11.2H134.4l2.7,6L113.8,34h14.3l5.5-3.8h26.3l2.7,3.8h14.5ZM140.8,24.7l10.7-7.9,5.5,7.9Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "111.8 11.2 125.7 11.2 95.1 34.1 79.7 34.1 65.2 11.2 78.7 11.2 89 27.5 111.8 11.2"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.5 9.3 56.9 9.3 61.5 15.6 27.1 15.6 25.8 19.6 54.7 19.6 53.1 24.3 24.1 24.3 22.8 28.1 57.4 28.1 55.3 34.2 7.6 34.2 14.2 15.2 11.5 9.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,10.2c18.2,0,24.9.9,23.3,7.1l-.1.6H294.6v-.6c0-1.7-8.7-1.8-12-1.8-6.5,0-13.2-.2-14,2.4-.8,2.4,5.3,1.3,12.4,1.3,22.5,0,24.2,3.3,22.9,7-2.5,7.1-8.2,8.6-29.1,8.6-11.1,0-27.4-.8-23.7-8.4H264l-.3,1c-.5,2.2,8.5,2,13.1,2,11,0,13.6-1.1,14.2-2.7.5-1.6-2.1-2-12.2-2-18.5,0-26.2-.5-23.8-6.8C257.6,11.1,268.5,10.2,284,10.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvansLogo);
export default __webpack_public_path__ + "static/media/Evans_logo.c244d4a77657aff193a3feb783dc64e2.svg";
export { ForwardRef as ReactComponent };